import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { POL_BASIC_01_Schema } from './POL_BASIC_01_Schema';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(POL_BASIC_01_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['PolicyAndGoals', 'getPolBasicR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.PolicyAndGoals.getPolBasicR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, POL_BASIC_01_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.PolicyAndGoals.savePolBasicU1,
      payload
    );
  }, options);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, POL_BASIC_01_Schema.mapper.delete1);
    return apiRequest(
      'post1',
      Global.urls.PolicyAndGoals.deletePolBasicD1,
      payload
    );
  }, options);
};
